// Etapa 19: textos e regras dos KPIs de uso do dashboard (GET /audit/stats).
// Funções puras: o componente só mostra o que elas devolvem.
import { traduzirMotivo } from './auditLabels';
import { seloDoCertificado } from './certificateStatus';

/** Períodos que o dashboard oferece (o servidor aceita de 1 a 90 dias). */
export const PERIODOS_EM_DIAS = [7, 30, 90] as const;
export const PERIODO_PADRAO = 30;

/** Só owner e admin veem os cartões (o servidor responde 403 para member). */
export function podeVerEstatisticas(role: string | null | undefined): boolean {
  return role === 'owner' || role === 'admin';
}

export function usosPorExtenso(quantidade: number): string {
  return `${quantidade} ${quantidade === 1 ? 'uso' : 'usos'}`;
}

/** Credenciais sem titular chegam com o nome vazio. */
export function nomeDoTitular(nome: string | null | undefined): string {
  return nome ? nome : 'Sem titular';
}

/** 0,75 → "75%". */
export function formatarTaxa(taxa: number): string {
  return `${Math.round(taxa * 100)}%`;
}

/** "host · motivo"; host ou motivo ausentes são omitidos. */
export function descricaoDaFalha(host: string | null | undefined, motivo: string | null | undefined): string {
  const partes = [host, motivo ? traduzirMotivo(motivo) : null].filter(Boolean);
  return partes.length > 0 ? partes.join(' · ') : 'Motivo não informado';
}

/** "3 de 4 entraram (75%)". */
export function resumoDoAbrirJaLogado(logou: number, total: number): string {
  return `${logou} de ${total} ${total === 1 ? 'entrou' : 'entraram'} (${formatarTaxa(total ? logou / total : 0)})`;
}

/** "Vence hoje" / "Vence em N dias" (o mesmo texto do selo da tela de certificados). */
export function textoDoVencimento(dias: number): string {
  return seloDoCertificado({ active: true, days_to_expire: dias }).texto;
}

/** "Mostrando 50 de 80" só quando a lista foi cortada. */
export function textoDoCorte(mostradas: number, total: number): string | null {
  return total > mostradas ? `Mostrando ${mostradas} de ${total}` : null;
}
